import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import moment from "moment";

/**
 * Export data to PDF
 * @param {Array} headers - Array of header strings
 * @param {Array} data - Array of rows (arrays)
 * @param {String} filename - Optional file name
 */
export const exportToPdf = (headers, data, filename = "exported-data") => {
  const doc = new jsPDF();
  doc.text(filename.replace(/-/g, " "), 20, 20);

  autoTable(doc, {
    head: [headers],
    body: data,
    startY: 25,
    styles: { fontSize: 9 },
    headStyles: {
      fillColor: [63, 81, 181],
      textColor: 255,
    },
  });

  doc.save(`${filename}_${moment().format("YYYY-MM-DD")}.pdf`);
};

/**
 * Export data to Excel
 * @param {Array} headers - Array of header strings
 * @param {Array} data - Array of row objects (key should match header names)
 * @param {String} filename - Optional file name
 */
export const exportToExcel = (headers, data, filename = "exported-data") => {
  const formattedData = data.map((row) => {
    const rowObj = {};
    headers.forEach((header, index) => {
      rowObj[header] = row[index];
    });
    return rowObj;
  });

  const ws = XLSX.utils.json_to_sheet(formattedData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, `${filename}_${moment().format("YYYY-MM-DD")}.xlsx`);
};

/**
 * Export data to Word
 * @param {Array} headers - Array of header strings
 * @param {Array} data - Array of rows (arrays)
 * @param {String} filename - Optional file name
 */
export const exportToWord = (headers, data, filename = "exported-data") => {
  const headerText = `${filename.replace(/-/g, " ")}\n\n`;
  const columns = headers.join("\t");

  const rows = data.map((row) => row.join("\t")).join("\n");

  const content = [headerText, columns, rows].join("\n");
  const blob = new Blob([content], { type: "application/msword" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${filename}_${moment().format("YYYY-MM-DD")}.doc`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
